export default "__VITE_ASSET__AVI5172i__"